/**
 * Per-browser UI preferences (sidebar state, theme). Storage can be blocked
 * (private mode), so every access is guarded and falls back to the default.
 */
export function readPreference<T extends string>(
  key: string,
  allowed: readonly T[],
  fallback: T
): T {
  try {
    const value = window.localStorage.getItem(key);
    return allowed.includes(value as T) ? (value as T) : fallback;
  } catch {
    return fallback;
  }
}

/** Free-text preference (e.g. a device id); "" when unset or blocked. */
export function readTextPreference(key: string): string {
  try {
    return window.localStorage.getItem(key) ?? "";
  } catch {
    return "";
  }
}

export function writePreference(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // Not persisted; the setting still applies for this page view.
  }
}

export const SIDEBAR_KEY = "rkm.sidebar";
export const THEME_KEY = "rkm.theme";
